import gsap from 'gsap';
import * as PIXI from 'pixi.js';
import { FixedSizeFitContainer, ResponsiveSizeContainer, ResponsiveView } from "../../../singlegame/ResponsiveHelpers";
import { serviceProvider } from "../../../singlegame/SinglegameServiceMap";
import { ITimeout } from "../../Context/Timeout";
import { assertNotNullish } from "../../debug";
import { GetOrientation, Orientation } from "../../FitScreen";
import { Color, CreateSpineResources, Get, Log, NextTask, Point, Rect, Scale, Size } from "../../MyHelpers";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage } from "../../ResourceManager/ResourceManager";
import { service } from "../../services";
import { FillingPotFeature, Settings } from "../../Settings";
import { FountainPIXI } from "../FountainAnimationPIXI";
import { SlotSymbol } from "../SlotSymbol";
import { ReelSymbolsToDisplay } from "../SpinAnimation/ReelMapper";
import { SymbolTypeAnim } from "../SpineSymbols/SymbolsCollection";
import { ITransitionFactoryPIXIAPP } from "../Transition/ITransitionFactoryPIXIAPP";
import { TransitionFactoryPIXIAPP } from "../Transition/TransitionFactoryPIXIAPP";
import { FreegameBonusParams } from "./FreegameBonus";
import { FreegameBonusPIXIAPP, TextureDialogLanguage } from "./FreegameBonusPIXIAPP";
import { FreegameStates } from "./FreegameState";
import { Spine } from '@modules/pixi-spine';
import { UniReelPIXIAPP } from '../UniReel/UniReelPIXIAPP';
import { SpinnableReelsBigCanvas } from '../SpinAnimation/SpinnableReelsBigCanvas';
import { SpinAnimation } from '../SpinAnimation/SpinAnimation';
import { ReelSetMapper } from '../SpinAnimation/ReelSetMapper';
import { WinLinesAnimationParams, WinLinesDrawOrder } from '../WinLines/GenericWinLinesAnimation';
import { PlusOneParams } from './GenericPlusOneAnimation';
import { IUniReelPIXIAPP } from '../UniReel/IUniReelPIXIPP';
import { WinLineMarkers } from '../WinLineMarkers';
import { SymbolPositionToAnimate } from '../SymbolsAnimation';
import { LineWin } from '../../../singlegame/singlegame_api';
import { WinSquaresAnimationsSpinePIXIAPPGridLimited, WinSquaresAnimationsSpinePIXIAPPGridLineLoopLimited } from '../WinLines/WinSquaresAnimationsSpinePIXIAPP';


export class FreegameBonusPIXIAPPResponsive extends FreegameBonusPIXIAPP {

	protected override timeoutFreeGameFinalMessage: ITimeout;
	protected fountainAnimation: FountainPIXI = serviceProvider.Resolve("FountainPIXI");
	private uniReelPixiApp: IUniReelPIXIAPP = null;
	private windowRect: Rect = null;

	public constructor(gameName: string, params: FreegameBonusParams) {
		super(gameName, params);

		this.uniReelPixiApp = params?.uniReelPixiApp?.Copy() ?? null;
		this.timeoutFreeGameFinalMessage = this.systemContext.TimingContext().CreateTimeout("timeoutFreeGameFinalMessage", 1000, () => {
			this.stateMachine.ChangeState(FreegameStates.FinalMessage);
			// this.bonusGameAwardViewPIXIAPP.visible = true;
			// Hide the container using GSAP
			if (this.bonusGameInfoStatsPIXIAPP != null) gsap.to(this.bonusGameInfoStatsPIXIAPP, { alpha: 0, duration: 1 });
			//show container win awward using GSAP
			// let xPosition = window.innerWidth/2 - this.statsContainer.width/2;
			// if (Settings.Screens == 2 && this.bonusName == "FreeGameBonus" || Settings.Enable2plus1 == true && this.bonusName == "FreeGameBonus" ) xPosition = Scale.X(36);
			if (this.bonusGameAwardViewPIXIAPP != null) gsap.to(this.bonusGameAwardViewPIXIAPP, { alpha: 1, duration: 1 })//gsap.to(this.bonusGameAwardViewPIXIAPP, { x: xPosition, duration: 1, ease: Elastic.easeOut.config(0.50, 0.4)});

		});
	}

	public override async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {

		await this.fillingPotFeature?.PrepareResources(loadingStage, resourceManager);
		// await SlotGameType1Shared.Instance().ResourcesPrepare(loadingStage, resourceManager , this.params.jackpotRequired);

		if (loadingStage == LoadingStage.GamesPreload) {
			await this.PrepareSpineResources(resourceManager);
			await this.winMessageAnimation.PrepareResources(resourceManager);
		}
		else if (loadingStage == LoadingStage.Games) {

			//move for create different family for feature
			await this.fillingPotFeature?.CreateFamilyAndPrepareResources(resourceManager, this.params.gameConfig.poppetPlusPot != null ? this.params.gameConfig.poppetPlusPot : false, this.spinnableReels);
			await this.BasePrepare(resourceManager);

			//Background and Construct Reels
			await this.PrepareBackgroundReel(resourceManager);

			await this.ConstructReels();

			let params: PlusOneParams = {
				viewSize: this.params.screenSize,
				spinnableReels: this.spinnableReels,
				logGroup: this.logGroup,
				resid: this.resid,
				bonusName: this.bonusName,
				maxAdditionalFreegames: this.maxAdditionalFreegames,
				gameBonusResourcesBasePath: this.params.gameBonusResourcesBasePath,
				commonBonusResourcesBasePath: this.params.commonBonusResourcesBasePath,
			};

			this.plusOneAnim = this.plusOneAnimFactory.CreatePlusOnePIXIAPPResponsive(params);
			//this.bigSymbolAnim = new BigSymbolAnim(this.params.availableSymbolsMap, this.spinnableReels);

			/*
			this.audio.AddTrack(new Track(this.params.gameResourcesBasePath + "tracks/background" + Settings.audioFormat, this.resid.ScopedResourceName("background")));
			this.audio.AddTrack(new Track(this.params.gameResourcesBasePath + "tracks/backgroundend" + Settings.audioFormat, this.resid.ScopedResourceName("backgroundend")));
			this.audio.AddTrack(new Track(this.params.gameResourcesBasePath + "tracks/transition" + Settings.audioFormat, this.resid.ScopedResourceName("transition")));
			this.audio.AddTrack(new Track(this.params.gameResourcesBasePath + "tracks/pick" + Settings.audioFormat, this.resid.ScopedResourceName("pick")));
			this.audio.AddTrack(new Track(this.params.gameResourcesBasePath + "tracks/remaining" + Settings.audioFormat, this.resid.ScopedResourceName("remaining")));

			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/bonustriggered" + Settings.audioFormat, this.resid.ScopedResourceName("triggered")));
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/plusone" + Settings.audioFormat, this.resid.ScopedResourceName("plusone")));
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/plusonemove" + Settings.audioFormat, this.resid.ScopedResourceName("plusonemove")));
			*/
			await this.PrepareWinLines(resourceManager);
			await this.AudioPrepare(resourceManager);

			await this.FeaturesPrepare(resourceManager);
			await this.BigWinPrepare(resourceManager);

			await this.PrepareHistory(resourceManager);
			await this.PrepareAnticipation(resourceManager)

		}
	}

	protected override async PrepareWinLines(resourceManager: IWriteOnlyResourceManager) {
		// construct win lines
		let winLinesAnimParams: WinLinesAnimationParams =
		{
			viewSize: this.params.screenSize,
			spinnableReels: this.spinnableReels,
			lines: this.params.playlines,
			logGroup: this.logGroup,
			resid: this.resid,
			systemContext: this.systemContext,
			slotWindow: this.params.windowRectangle,
			slotWindowSymbolSize: this.spinnableReels.GetWindowSymbolSize(),
			colorLineMarkers: this.params.colorLineMarkers,
			speedFactorAnimation: this.params.winAnimationSpeedFactor,
			gameName: this.gameName,
			winLinesTypeStyle: this.params.gameConfig.winLinesTypeStyle,
			gameColor: this.params.gameConfig.colorLed,
		};

		// TODO replace with factory
		this.winLinesAnimation = new WinSquaresAnimationsSpinePIXIAPPGridLimited(winLinesAnimParams);

		//
		this.winLineMarkers = new WinLineMarkers(this.params.windowRectangle, this.spinnableReels.GetWindowSymbolSize(), this.params.playlines);

		this.winLinesAnimation.AddStartLineCallback((line: LineWin, color: Color) => {
			this.audio.PlayLoop(this.parentresid.ScopedResourceName("linecount"));
			this.audio.PlayLoop(this.parentresid.ScopedResourceName("lineCountBackground"));
		});

		this.winLinesAnimation.AddNextLineCallback((line: LineWin, color: Color, animateOnlyWinningSymbols: boolean) => {
			this.winLineMarkers.Show(line.LineIndex, color);
			this.panel.SetMessage(this.translator.t.linepay("" + (line.LineIndex + 1), service.moneyFormatter.FormatCreditCurrentDenom(line.Win)));
			let symbolPositions: SymbolPositionToAnimate[] = [];
			let lineindex: number = line.LineIndex;

			let symbolsToAnimate: number = this.params.playlines[lineindex].length;
			if (animateOnlyWinningSymbols) {
				symbolsToAnimate = line.SymbolCount;
			}

			for (let i = 0; i < symbolsToAnimate; i++) {
				symbolPositions.push(new SymbolPositionToAnimate(i, this.params.windowSymbolSize.Height - 1 - this.params.playlines[lineindex][i]));
			}

			// this.screenProtocol?.Send(new SlotGameMessages.WiningSymbol(line.SymbolIndex), this.screenProtocolScope);
			this.symbolsAnimation.Stop();
			try {
				if (this.params.gameConfig.symbolsType == SymbolTypeAnim.Sprites) {
					this.spinnableReels.StopSymbolsAnim();
					this.spinnableReels.PlaySymbolsAnim(symbolPositions, true);
				}
				else if (this.params.gameConfig.symbolsType == SymbolTypeAnim.Spine) {
					this.params.symbolCollection.PlayAnimationWinSymbolSpineSymbol(symbolPositions);
				}
			} catch (error) {
				Log.Error(this.logGroup, "Error playanim symbol", error);
			}

			symbolPositions = null;
			symbolsToAnimate = null;
			lineindex = null;
		});

		this.winLinesAnimation.AddCompleteCallbacks(() => {
			try {
				this.spinnableReels.StopSymbolsAnim();
			} catch (error) {
				Log.Error(this.logGroup, "Error stopsanim symbol", error);
			}
			this.winLineMarkers.Hide();
			this.audio.Stop(this.parentresid.ScopedResourceName("linecount"));
			this.audio.Stop(this.parentresid.ScopedResourceName("lineCountBackground"));

			this.stateMachine.ChangeState(FreegameStates.Collect);
			//this.DisableSymbolsAnimation();

		});

		await this.winLinesAnimation.PrepareResources(resourceManager);
		winLinesAnimParams = null;
		resourceManager = null;

	}

	protected override ConstructReels(): void {
		this.windowRect = this.params.windowRectangle;

		if (this.uniReelPixiApp) {
			this.uniReelPixiApp.Create()
			this.windowRect = this.uniReelPixiApp.GetReelsPosition();
		}
		this.spinnableReels = new SpinnableReelsBigCanvas(this.params.windowSymbolSize, this.windowRect, this.params.spinnableReelsParams, this.resid, this.systemContext);
		let spinnableReelsView: HTMLElement = this.spinnableReels.GetView();

		this.spinAnimation = new SpinAnimation(this.logGroup);
		this.reelSetMapper = new ReelSetMapper(this.params.windowSymbolSize, this.logGroup);

		//this.InitializeIsAnimation();

		spinnableReelsView = null;
	}

	public override Update(): void {

		this.spinAnimation.Update();
		//this.transition.Update();
		this.fountainAnimation.Update();

		this.features.forEach((feature) => feature.Update());

		this.symbolsAnimation.Update();
		//this.winMessageAnimation.Update();
		this.shakeAnimation.Update();
		this.winLinesAnimation.Update();
		this.plusOneAnim.Update();

		//Update for transition sprite ;
		this.transitionView.Update();
		//this.RedrawCanvas();
		this.fillingPotFeature?.Update();
		this.spinnableReels.Update();
	}

	protected override SetupWinLines() {
		let containerReels: PIXI.Container = null;
		if (this.params.gameConfig.winLinesDrawOrder == WinLinesDrawOrder.backSymbols) containerReels = this.fillingPotFeature?.GetReelContainer();
		this.winLinesAnimation.CreatePIXIAPP(containerReels);
		if (this.params.gameConfig.uniReel) {
			this.uniReelPixiApp.GetView().addChild(this.winLinesAnimation.ViewPIXIAPP());
		}
		else {
			this.containerBonusViewApp.addChild(this.winLinesAnimation.ViewPIXIAPP());
		}
	}

	protected override async OnBigWinEnd(): Promise<void> {
		let winCredit: number = service.moneyFormatter.CentsToCredit(this.simpleLastBonusAction.Win.TotalWin);

		if (this.winMessageAnimation.WillTrigger(this.bet, winCredit)) {
			this.winMessageAnimation.Start(this.bet, winCredit);
			this.fillingPotFeature?.OnStartBigWinShow();
			winCredit = null;
			this.bigWinCountAnimation.ViewPIXIAPP().visible = true;
			this.fountainAnimation.Create();
			await this.fountainAnimation.Start();
			// SlotGameType1Shared.Instance().smallFountainAnimation.Start(this.resid);
		}
	}


	protected override OnWinEnd(): void {
		// fast forward win count, if needed
		if (this.winCreditAnimation != null && this.winCreditAnimation.progress() != 1) {
			this.winCreditAnimation.progress(1, false);
		}

		this.symbolsAnimation.Stop();
		this.winMessageAnimation.Stop();
		this.fillingPotFeature?.OnEndBigWinShow();
		// SlotGameType1Shared.Instance().smallFountainAnimation.RequestStop(this.resid);
		this.fountainAnimation.Destroy();
		this.bigWinCountAnimation.ViewPIXIAPP().visible = false;
	}

	protected override PlayNextPlusOne(): void {
		this.plusOneAnim.ViewPIXIAPP().alpha = 1;
		let timeout = 0;
		this.plusOneTarget = this.spineFrame.parent.toGlobal(this.spineFrame.position);
		this.plusOneAnim.StartPlusOnePIXIAPP(this.plusoneSymbolsPosition.SymbolPositions[this.currentIndexPlusOneTrigger], new Point(this.plusOneTarget.x, this.plusOneTarget.y));

		this.audio.Play(this.resid.ScopedResourceName("plusone"));
		setTimeout(() => {
			this.audio.Play(this.resid.ScopedResourceName("plusonemove"))
		}, 1500);
		timeout += this.plusOneAnim.Duration();

		// refresh top screen
		setTimeout(() => {
			//this.screenProtocol?.Send(new FreegameMessages.PlusMessage(this.session), this.screenProtocolScope)
			this.ApplySession(this.session);
			//this.startValueSpinsText.get("spinsRemaning" + this.startArray[0]).text = this.session.left += 1;
			this.session.left += 1;
			if (this.spinsStats != null) this.spinsStats.text = this.translator.t.bonusSpinsRemainingAndTotal(this.session.played, this.totalSpins += 1);

			this.CheckifMorePlusOneExist();
		}, timeout);
	}

	public override GameExit(): void {
		this.uniReelPixiApp?.GetView().removeFromParent();
		this.uniReelPixiApp?.Destroy();

		super.GameExit();
		this.Created = false;
		this.lastOrientation = null;
	}

	public override async GameSelected(app: PIXI.Container): Promise<void> {

		app.removeChildren();

		this.gameViewApp = app;

		this.createResponsiveElements();

		const plusOneView = this.plusOneAnim.CreatePIXAPP();


		// let GameApp = this.gameViewApp as any as GameViewAppPixiResponsive;



		//create reels or filling pot
		if (Settings.fillingPotFeature == FillingPotFeature.Disable) {
			this.spinnableReels.Create(this.containerBonusViewApp, null);
		}
		if (Settings.fillingPotFeature == FillingPotFeature.Enable) {
			// this.fillingPotFeature?.Create(this.reelsContainer);
			this.shakeAnimation.CreateShakeAnimationPixi(this.fillingPotFeature?.GetReelContainer());
		}
		//create view main bonus

		this.CreateContainersPIXIAPPScreen1();
		//create info stats for 2screens
		this.CreateContainersPIXIAPPScreen2();
		//add plusone view pixi app
		if (this.params.gameConfig.uniReel) {
			this.uniReelPixiApp.GetView().addChild(plusOneView);
		}
		else {

			this.containerBonusViewApp.addChild(plusOneView);

		}
		this.plusOneAnim.ViewPIXIAPP().alpha = 0;
		//create Wild feature
		this.CreateFeatures();

		this.bigWinCountAnimation.CreatePIXIAPP();
		this.containerBonusViewApp.addChild(this.bigWinCountAnimation.ViewPIXIAPP());

		//winMessageAnimation Create PIXI
		this.winMessageAnimation.CreatePIXIAPP();
		this.freeGameBonusContainer.addChild(this.winMessageAnimation.ViewPIXIAPP());

		if (this.jackpotSharedShow != null) {
			this.jackpotSharedShow?.Create();
			this.containerBonusViewApp?.addChild(this.jackpotSharedShow?.View());
		}

		this.Created = true;
		this.OnResize();
	}

	protected override CreateFeatures() {
		// // EXPANDING WILD
		for (let [name, feature] of this.features) {
			//await feature.ResourcesLoaded(resourceManager);

			if (feature) {
				feature.CreatePIXIAPP();
				if (this.params.gameConfig.uniReel) {
					this.uniReelPixiApp.GetView().addChild(feature.ViewPIXIAPP());
				}
				else {
					this.containerBonusViewApp.addChild(feature.ViewPIXIAPP());
				}
			}
		};

		this.SetupWinLines();
		// if (Settings.Screens == 2) {
		// 	this.plusOneTarget.x = Scale.X(291);
		// 	this.plusOneTarget.y = Scale.Y(894);
		// }
		// else if (Settings.Enable2plus1 == true) {
		// 	this.plusOneTarget.x = Scale.X(291);
		// 	this.plusOneTarget.y = Scale.Y(1974)
		// }
	}

	protected override CreateContainersPIXIAPPScreen1(): void {

		if (Settings.touchToStop == true) {
			// AddMouseDownListener(this.gameViewApp.view, () => {
			// 	this.spinAnimation.RequestStop();
			// });
			this.gameViewApp.addEventListener('mousedown', () => {
				this.spinAnimation.RequestStop();
			});

		}

		this.anticipationAnimation?.Create(this.spinnableReels.GetReelBackgroundRect(), this.params.windowRectangle);

		if (this.anticipationAnimation?.GetView()) {
			this.containerBonusViewApp?.addChild(this.anticipationAnimation?.GetView());
		}

		this.messageContainerPIXIAPP = new PIXI.Container()
		this.messageContainerPIXIAPP.width = Scale.W(1920);
		this.messageContainerPIXIAPP.height = Scale.H(1080);
		// this.messageContainerPIXIAPP.position.x = (this.freeGameBonusContainer.fixedWidth - this.messageContainerPIXIAPP.width) / 2;
		// this.messageContainerPIXIAPP.y = (this.freeGameBonusContainer.fixedHeight - this.messageContainerPIXIAPP.height) / 2;
		// this.messageContainerPIXIAPP.y = - Scale.H(100);
		this.messageContainerPIXIAPP.name = "messageContainerApp";
		this.freeGameBonusContainer.addChild(this.messageContainerPIXIAPP);

		this.introMessageContainerPIXIAPP = new PIXI.Container();
		this.introMessageContainerPIXIAPP.width = Scale.W(1152);
		this.introMessageContainerPIXIAPP.height = Scale.H(648);
		this.introMessageContainerPIXIAPP.pivot.set(0, 0)//(Scale.W(1152) / 2, Scale.H(648) / 2);
		this.introMessageContainerPIXIAPP.x = (Scale.W(1920) / 2) - (Scale.W(1152) / 2) - Scale.X(70 / 2);
		this.introMessageContainerPIXIAPP.y = (Scale.W(1080) / 2) - (Scale.H(648) / 2);//- Scale.Y(75);
		this.introMessageContainerPIXIAPP.name = "introMessageContainer";
		this.introMessageContainerPIXIAPP.visible = false;
		this.messageContainerPIXIAPP.addChild(this.introMessageContainerPIXIAPP);

		let spriteintroSpanishMessageContainerApp = PIXI.Sprite.from(this.textureDialogBonus);
		spriteintroSpanishMessageContainerApp.width = Scale.W(1200),
			spriteintroSpanishMessageContainerApp.height = Scale.H(700);
		spriteintroSpanishMessageContainerApp.y = Scale.Y(-56.5)
		this.introMessageContainerPIXIAPP.addChild(spriteintroSpanishMessageContainerApp);


		let spriteintroTextureMessageContainerApp = PIXI.Sprite.from((this.textureByLanguage[this.translator.t.languageEnglish.toLocaleLowerCase()] as TextureDialogLanguage).textureBonusIntro);
		//spriteintroTextureMessageContainerApp.width = Scale.W(1052),
		//spriteintroTextureMessageContainerApp.height = Scale.H(548);
		spriteintroTextureMessageContainerApp.scale.set(Scale.H(1), Scale.W(1));
		spriteintroTextureMessageContainerApp.anchor.set(0.5, 0.5);
		spriteintroTextureMessageContainerApp.x = Scale.W(1152) / 2
		spriteintroTextureMessageContainerApp.y = (Scale.H(648) / 2) - Scale.W(80);
		this.introMessageContainerPIXIAPP.addChild(spriteintroTextureMessageContainerApp);




		let buttonIntroContainerApp: PIXI.Container = new PIXI.Container()
		buttonIntroContainerApp.name = "buttonIntroContainerApp"
		buttonIntroContainerApp.width = Scale.W(600);
		buttonIntroContainerApp.height = Scale.H(300);
		buttonIntroContainerApp.y = Scale.H(600);
		buttonIntroContainerApp.x = Scale.H(1152) / 2;
		buttonIntroContainerApp.pivot.set(Scale.W(600) / 2, Scale.H(300) / 2);
		buttonIntroContainerApp.interactive = true;
		this.introMessageContainerPIXIAPP.addChild(buttonIntroContainerApp);

		let spritebuttonIntroContainerApp = PIXI.Sprite.from(this.textureButtonBonus);
		spritebuttonIntroContainerApp.width = Scale.W(600),
			spritebuttonIntroContainerApp.height = Scale.H(300);
		buttonIntroContainerApp.addChild(spritebuttonIntroContainerApp);

		//create text style
		let textstyle = new PIXI.TextStyle({
			fontFamily: 'NotoSansDisplay-Bold',
			fontSize: Scale.fh(100),
			//fontStyle: 'italic',
			fontWeight: 'bold',
			fill: ["#F2E416", "#F2BE22", "#C2760E", "#F2BE22", "#F2E416"], // gradient
			stroke: 'black',
			strokeThickness: Scale.fh(10),
			wordWrap: true,
			wordWrapWidth: Scale.fh(300),
			lineJoin: 'round',
			textBaseline: "middle",
		});
		//this.app.renderer.view.style.position = 'fixed';
		let startTextView = new PIXI.Text(this.translator.t.freegameStart, textstyle);
		startTextView.anchor.set(0.5, 0.5);
		startTextView.x = (Scale.W(600) / 2);
		startTextView.y = (Scale.W(300) / 2);
		startTextView.context.textBaseline = "alphabetic";
		buttonIntroContainerApp.addChild(startTextView);

		//spritebuttonIntroContainerApp.tint = 0xff0000;
		buttonIntroContainerApp.addListener("pointerdown", (ev: MouseEvent) => {
			if (this.stateMachine.State() == FreegameStates.NoPickIntro) {
				// Log.Debug(this.logGroup, "Intro message confirmed");
				this.stateMachine.ChangeState(FreegameStates.WaitFirstSpin);
			}
			else {
				Log.Error(this.logGroup, "Can't confirm intro message, current state: " + FreegameStates[this.stateMachine.State()] + ", required state: " + FreegameStates[FreegameStates.IntroMessage]);
			}
		});

		//Create Final MessageContainer
		this.finalMessageContainerPIXIAPP = new PIXI.Container();
		this.finalMessageContainerPIXIAPP.width = Scale.W(1152);
		this.finalMessageContainerPIXIAPP.height = Scale.H(648);
		this.finalMessageContainerPIXIAPP.pivot.set(0, 0);//(Scale.W(1152) / 2, Scale.H(648) / 2)
		this.finalMessageContainerPIXIAPP.x = (Scale.W(1920) / 2) - (Scale.W(1152) / 2) - Scale.X(70 / 2);
		this.finalMessageContainerPIXIAPP.y = (Scale.W(1080) / 2) - (Scale.H(648) / 2);//- Scale.Y(75);
		this.finalMessageContainerPIXIAPP.name = "finalMessageContainerApp";
		this.finalMessageContainerPIXIAPP.visible = false;
		this.finalMessageContainerPIXIAPP.interactiveChildren = true;
		this.finalMessageContainerPIXIAPP.interactive = true;
		this.messageContainerPIXIAPP.addChild(this.finalMessageContainerPIXIAPP);


		let spritefinalSpanishMessageContainerApp = PIXI.Sprite.from(this.textureDialogBonus);
		spritefinalSpanishMessageContainerApp.width = Scale.W(1200),
			spritefinalSpanishMessageContainerApp.height = Scale.H(700);
		spritefinalSpanishMessageContainerApp.y = Scale.Y(-56.5)
		this.finalMessageContainerPIXIAPP.addChild(spritefinalSpanishMessageContainerApp);


		let spritefinalTextureMessageContainerApp = PIXI.Sprite.from((this.textureByLanguage[this.translator.t.languageEnglish.toLocaleLowerCase()] as TextureDialogLanguage).textureBonusFinal);
		//spritefinalTextureMessageContainerApp.width = Scale.W(1052),
		//spritefinalTextureMessageContainerApp.height = Scale.H(548);
		spritefinalTextureMessageContainerApp.scale.set(Scale.H(1), Scale.W(1));
		spritefinalTextureMessageContainerApp.anchor.set(0.5, 0.5);
		spritefinalTextureMessageContainerApp.x = Scale.W(1152) / 2
		spritefinalTextureMessageContainerApp.y = (Scale.H(648) / 2) - Scale.W(80);
		this.finalMessageContainerPIXIAPP.addChild(spritefinalTextureMessageContainerApp);



		let finalbuttonIntroContainerApp: PIXI.Container = new PIXI.Container()
		finalbuttonIntroContainerApp.name = "finalbuttonIntroContainerApp"
		finalbuttonIntroContainerApp.width = Scale.W(600);
		finalbuttonIntroContainerApp.height = Scale.H(300);
		finalbuttonIntroContainerApp.y = Scale.H(600);
		finalbuttonIntroContainerApp.x = Scale.H(1152) / 2;
		finalbuttonIntroContainerApp.pivot.set(Scale.W(600) / 2, Scale.H(300) / 2);
		finalbuttonIntroContainerApp.interactive = true;
		finalbuttonIntroContainerApp.interactiveChildren = true;

		this.finalMessageContainerPIXIAPP.addChild(finalbuttonIntroContainerApp);

		let spritebuttonFinalContainerApp = PIXI.Sprite.from(this.textureButtonBonus);
		spritebuttonFinalContainerApp.width = Scale.W(600),
			spritebuttonFinalContainerApp.height = Scale.H(300);
		//spritebuttonFinalContainerApp.tint = 0xff0000;
		finalbuttonIntroContainerApp.addChild(spritebuttonFinalContainerApp);

		let finalTextView = new PIXI.Text(this.translator.t.freegameExit, textstyle);
		finalTextView.x = (Scale.W(600) / 2);
		finalTextView.y = (Scale.W(300) / 2);
		finalTextView.anchor.set(0.5, 0.5),
			finalTextView.context.textBaseline = "alphabetic";
		finalbuttonIntroContainerApp.addChild(finalTextView);

		finalbuttonIntroContainerApp.addListener("pointerdown", (ev: MouseEvent) => {
			if (this.stateMachine.State() == FreegameStates.FinalMessage) {
				//this.CreateTransitionPixi();
				//SHOW VIDEO TRANSITION
				this.Spin();
			}
			else {
				Log.Error(this.logGroup, "Can't confirm intro message, current state: " + FreegameStates[this.stateMachine.State()] + ", required state: " + FreegameStates[FreegameStates.IntroMessage]);
			}
		});



		this.translator.SetOnLanguageChangedCallback(() => {
			spriteintroTextureMessageContainerApp.texture = (this.textureByLanguage[this.translator.t.languageEnglish.toLocaleLowerCase()] as TextureDialogLanguage).textureBonusIntro;
			spritefinalTextureMessageContainerApp.texture = (this.textureByLanguage[this.translator.t.languageEnglish.toLocaleLowerCase()] as TextureDialogLanguage).textureBonusFinal;
			startTextView.text = this.translator.t.freegameStart;
			finalTextView.text = this.translator.t.freegameExit;
			//skipMessageCommets.text = this.translator.t.skipMessageCommets;
		});
		// this.skipMessageHide = this.systemContext.TimingContext().CreateTimeout("skipMessageHideShowTime", 1500, () => {
		// 	this.skipCometMessageContainer.visible = false;
		// });

		//append winlines pixi app
		//this.containerBonusViewApp.addChild(this.winLinesAnimation.ViewPIXIAPP());
	}

	protected override CreateContainersPIXIAPPScreen2() {

		this.bonusGameInfoStatsPIXIAPP = new PIXI.Container();
		this.bonusGameInfoStatsPIXIAPP.name = "bonusGameInfoStatsPIXIAPP";
		this.statsContainer.addChild(this.bonusGameInfoStatsPIXIAPP);
		this.CreateInfoStats(this.bonusGameInfoStatsPIXIAPP);
		this.CreateAwarViewPIXIAPP();

	}

	protected override CreateInfoStats(container: PIXI.Container) {

		//create spine frame
		this.spineFrame = CreateSpineResources(this.jsonSpinsRemainingSpine);
		globalThis.stats = this.spineFrame;
		container.addChild(this.spineFrame);
		this.spineFrame.name = "FrameSpinsRemaining";
		this.spineFrame.pivot.set(this.spineFrame.spineData.width / 2, this.spineFrame.spineData.height / 2);
		this.spineFrame?.state.setAnimation(0, "anim", true);
		//only use if you are win double bonus
		//create Win Text SRA
		this.spinsStats = new PIXI.Text(this.translator.t.bonusSpinsRemainingAndTotal(this.session.played, this.totalSpins), {
			fontFamily: 'NotoSansDisplay-Bold',
			fontSize: 50,
			fontWeight: 'bold',
			fill: ["#F20505", "#F20505", "#F20505", "#F20505", "#F20505"], // gradient
			stroke: 'white',
			strokeThickness: 10,
			dropShadow: true,
			dropShadowColor: "#000000",
			dropShadowDistance: 5,
			dropShadowAngle: 0.52,
			dropShadowAlpha: 1,
			//wordWrap: true,
			lineJoin: 'round',
			//textBaseline : "middle",
		});
		this.spinsStats.anchor.set(0.5, 0.5);
		this.spinsStats.scale.y = -1;
		//this.spinsStats.position.set(Scale.X(1644), 0 );

		//add text into spine
		const containerValue = this.spineFrame.children.find((child) => child.name == "containerValue") as PIXI.Container;
		assertNotNullish(containerValue, "PlusOneAnimation: containerValue not found in spineFrame");
		containerValue.addChild(this.spinsStats);

		this.translator.SetOnLanguageChangedCallback(() => {
			this.spinsStats.text = this.translator.t.bonusSpinsRemainingAndTotal(this.session.played, this.totalSpins)
		});

	}


	protected override CreateAwarViewPIXIAPP() {
		this.bonusGameAwardViewPIXIAPP = new PIXI.Container();
		this.bonusGameAwardViewPIXIAPP.name = "bonusGameAwardViewPIXIAPP";
		this.bonusGameAwardViewPIXIAPP.alpha = 0;

		this.statsContainer.addChild(this.bonusGameAwardViewPIXIAPP);


		//create container and spine bonus title
		let bonusWinAwardTitle = new PIXI.Container();
		bonusWinAwardTitle.name = "bonusWinAwardTitle";
		this.bonusGameAwardViewPIXIAPP.addChild(bonusWinAwardTitle);
		this.spineBonusTitleAward = CreateSpineResources(this.jsonBonusWinTitleSpine);
		//this.spineBonusTitleAward.scale.set(Scale.XY(1));
		this.spineBonusTitleAward.state.timeScale = 1.5;
		bonusWinAwardTitle.x = Scale.X(78);
		bonusWinAwardTitle.y = Scale.Y(199);
		bonusWinAwardTitle.addChild(this.spineBonusTitleAward);



		//create container and spine bonus title
		let bonusWinAwardContainer = new PIXI.Container();
		bonusWinAwardContainer.name = "bonusWinAwardContainer";
		this.bonusGameAwardViewPIXIAPP.addChild(bonusWinAwardContainer);
		this.spineWinAward = CreateSpineResources(this.jsonWinAwardBonusSpine);
		this.spineWinAward.state.timeScale = 1.5
		//bonusWinAwardContainer.x = Settings.ScreenWidth / 2;
		bonusWinAwardContainer.y = Settings.ScreenHeight / 2;
		bonusWinAwardContainer.addChild(this.spineWinAward);

		console.log("Spine:", this.spineWinAward);



		//create container
		let containerValue = new PIXI.Container();
		containerValue.name = "containerValue";
		//containerValue.pivot.set(this.positionSpinnableReelsSpinePivotContainer.width, this.positionSpinnableReelsSpinePivotContainer.height);
		containerValue.scale.set(1, -1);
		containerValue.position.y = (Settings.ScreenHeight * (Settings.Screens - 1)) * -1;


		//add container to spine
		let containerchildrensSpine = this.spineWinAward.children as PIXI.Container[];
		containerchildrensSpine.forEach((container) => {
			if (container.name == "containerValue") {
				//create Win Text SRA
				this.containerValueWinAwardText = new PIXI.Text("?", {
					fontFamily: 'NotoSansDisplay-Bold',
					fontSize: 230,
					fontWeight: 'bold',
					fill: ["#F2E416", "#F2BE22", "#C2760E", "#F2BE22", "#F2E416"], // gradient
					stroke: 'black',
					strokeThickness: 10,
					//wordWrap: true,
					lineJoin: 'round',
					//textBaseline : "middle",
				});
				this.containerValueWinAwardText.scale.set(1, -1);
				this.containerValueWinAwardText.anchor.set(0.5, 0.5);
				container.addChild(this.containerValueWinAwardText)
			}
		});

		containerchildrensSpine = null;


		//create Win Text SRA
		let containerValueWinAward = new PIXI.Text("?", {
			fontFamily: 'NotoSansDisplay-Bold',
			fontSize: 120,
			fontWeight: 'bold',
			fill: ["#F2E416", "#F2BE22", "#C2760E", "#F2BE22", "#F2E416"], // gradient
			stroke: 'black',
			strokeThickness: 10,
			//wordWrap: true,
			lineJoin: 'round',
			//textBaseline : "middle",
		});
		containerValueWinAward.anchor.set(0.5, 0.5);
		containerValue.addChild(containerValueWinAward)
	}


	protected responsiveView: ResponsiveView;
	protected responsiveStatsContainer: ResponsiveSizeContainer;
	protected statsContainer: FixedSizeFitContainer;
	protected baseGameContainer: ResponsiveSizeContainer;
	protected freeGameBonusContainer: FixedSizeFitContainer;
	protected panelContainer: ResponsiveSizeContainer;

	private createResponsiveElements(): void {

		this.responsiveView = new ResponsiveView(window.innerWidth, window.innerHeight, { color: 0x220000, name: `responsive-view` });

		this.responsiveStatsContainer = new ResponsiveSizeContainer(0, 0, 1, 0.13, NaN, { color: 0x550000, secondaryColor: 0x005500, name: 'stats-container-responsive' });
		this.responsiveView.addChild(this.responsiveStatsContainer);

		this.statsContainer = new FixedSizeFitContainer(Scale.W(1920), Scale.H(1080), { color: 0x550000, secondaryColor: 0x005500, name: 'stats-container' });
		this.responsiveStatsContainer.addChild(this.statsContainer);

		this.baseGameContainer = new ResponsiveSizeContainer(0, 0.13, 1, 0.87, NaN, { color: 0x990000, name: 'base-game-container' });
		this.responsiveView.addChild(this.baseGameContainer);

		this.freeGameBonusContainer = new FixedSizeFitContainer(Scale.W(1920), Scale.H(1080), { color: 0xbb0000, name: 'reels-container' });
		this.baseGameContainer.addChild(this.freeGameBonusContainer);

		if (this.uniReelPixiApp) {
			this.uniReelPixiApp.Create();
			this.containerBonusViewApp = this.uniReelPixiApp.GetReelsContainer();
			this.freeGameBonusContainer.addChild(this.uniReelPixiApp.GetView());
		}
		else {

			this.containerBonusViewApp = new PIXI.Container();
			this.containerBonusViewApp.name = "containerBonusViewApp" + this.bonusName + "Responsive";
			this.freeGameBonusContainer.addChild(this.containerBonusViewApp);
		}

		this.panelContainer = new ResponsiveSizeContainer(0, 0.85, 1, 0.15, NaN, { color: 0xee0000, name: 'panel-container' });
		this.responsiveView.addChild(this.panelContainer);

		this.gameViewApp.addChild(this.responsiveView);


	}

	public override async PrepareTransition(resourceManager: IWriteOnlyResourceManager) {
		let transitionResources = {
			audio: this.audio,
			logGroup: this.logGroup,
			systemContext: this.systemContext,
			gameName: this.gameName,
			resid: this.resid,
			fadeOut: true,
			skelentonDataSpine: globalThis?.jackpotDisplayGlobal?.GetSpineSkeleton() ?? null,
			transitionPIXITypeStyle: this.params.gameConfig.transitionPIXITypeStyle,
			bonusCommonPath: this.params.commonBonusResourcesBasePath,
			bonusName: this.bonusName,
		};

		let transitionViewFactory: ITransitionFactoryPIXIAPP = new TransitionFactoryPIXIAPP();
		this.transitionView = await transitionViewFactory.CreatePIXIAPPResponsive(transitionResources);
		await this.transitionView?.PrepareResources(resourceManager);
		this.transitionView.onTransitionEnd = () => {
			this.OnTransitionEnded()
		}
		this.transitionView.onTransitionStart = () => {
			this.OnTransitionStarted()
		}
	}

	public override DrawSymbol(reelIndex: number, rowIndex: number): void {
		try {

			let canvasPIXI: PIXI.AnimatedSprite = this.spinnableReels.symbolPIXISprite?.[reelIndex]?.[rowIndex];
			if (!canvasPIXI) {
				// no canvas to draw
				return;
			}

			if (this.params.gameConfig.symbolsType == SymbolTypeAnim.Spine) this.params.symbolCollection.DestroySymbol(reelIndex, rowIndex);
			let symbolToDisplay: ReelSymbolsToDisplay = this.currentSymbols[reelIndex][rowIndex];
			let symbol: SlotSymbol = this.params.availableSymbols[symbolToDisplay.symbolIndex];
			//canvas.renderable = true;
			let img = PIXI.Texture.from(this.params.symbolCollection.symbolCollectionMap.get("Symbol_" + symbol.ID).imgResource);
			//canvasPIXI.name = "Symbol_" + symbol.ID
			canvasPIXI.texture = img;
			const playWindow = this.params.initData.PlayWindow;
			const scalePercentage = !this.params.gameConfig.symbolScale ? 1 : this.params.gameConfig.symbolScale[`${playWindow.Width}x${playWindow.Height}`]
			//let scalePercentage = this.params.gameConfig.symbolScale[`${playWindow.Width}x${playWindow.Height}`] == undefined ? 1 : this.params.gameConfig.symbolScale[`${playWindow.Width}x${playWindow.Height}`] ;

			let scaleWidth = (this.spinnableReels?.GetSymbolSize().Width / img.width) * scalePercentage;
			let scaleHeight = (this.spinnableReels?.GetSymbolSize().Height / img.height) * scalePercentage
			let scaleProm = (scaleHeight + scaleWidth) / 2;
			canvasPIXI.scale.set(scaleProm);
			canvasPIXI.visible = true;
			canvasPIXI.anchor.set(0.5);
			canvasPIXI.position.set(this.spinnableReels.GetSymbolSize().Width / 2, this.spinnableReels.GetSymbolSize().Height / 2);
			this.scatterRandomAwardFeature?.DrawPIXI(reelIndex, symbolToDisplay.reelPositionIndex, rowIndex, symbol, canvasPIXI, null, this.params.symbolCollection.symbolCollectionMap.get("Symbol_" + symbol.ID).showAward);
			this.params.symbolCollection.SetSymbolCache("Symbol_" + symbol.ID, reelIndex, rowIndex, canvasPIXI);
		}
		catch (ex) {
			//Log.Error(this.logGroup, "Error drawing symbol", ex);
		}
	}

	protected override OnTransitionStarted() {
		// play transition audio
		this.audio.Play(this.resid.ScopedResourceName("transitionaudio"));
		this.started = true;
	}

	protected lastOrientation: Orientation = null;

	public override OnResize(): void {
		this.responsiveView?.setAvailableSize(window.innerWidth, window.innerHeight);
		this.transitionView?.OnResize();
		this.ScaleGame();
		this.resizeCallback?.();
	}

	protected scale: number = 1;
	private ScaleGame(): void {

		if (!this.Created) return;

		const statsSize = new Size(398, 130);

		const scaleX = this.statsContainer.fixedWidth / statsSize.Width;
		const scaleY = this.statsContainer.fixedHeight / statsSize.Height;
		const scale = Math.min(scaleX, scaleY);
		this.scale = scale;

		this.SetToDefault();

		// if (this.lastOrientation != GetOrientation()) {

		// this.bonusGameInfoStatsPIXIAPP.scale.set(scale * 3);
		// this.bonusGameInfoStatsPIXIAPP.pivot.set(statsSize.Width / 2, statsSize.Height / 2);
		// this.bonusGameInfoStatsPIXIAPP.position.x = this.statsContainer.fixedWidth / 2;
		// this.bonusGameInfoStatsPIXIAPP.position.y = this.statsContainer.fixedHeight / 2;
		this.spineFrame.scale.set(scale);
		this.spineFrame.position.set(this.statsContainer.fixedWidth / 2, this.statsContainer.fixedHeight / 2);


		// this.bonusGameAwardViewPIXIAPP.scale.set(scale);
		// this.bonusGameAwardViewPIXIAPP.position.x = this.statsContainer.fixedWidth / 2 - this.bonusGameAwardViewPIXIAPP.width / 2;

		this.bonusGameAwardViewPIXIAPP.position.y = GetOrientation() == Orientation.Landscape
			? this.statsContainer.fixedHeight / 8 - this.bonusGameAwardViewPIXIAPP.height / 4
			: this.statsContainer.fixedHeight - this.bonusGameAwardViewPIXIAPP.height;


		// }
		this.lastOrientation = GetOrientation();

		this.CreatePlusOneTargetResponsive();

	}

	// private getElementPosition(element: PIXI.DisplayObject, renderer: PIXI.Renderer): PIXI.Point {
	// 	// Get global position within PixiJS canvas
	// 	const globalPos = element.getGlobalPosition(new PIXI.Point());

	// 	// Get canvas's viewport bounding rect
	// 	const canvasRect = renderer.view.getBoundingClientRect();

	// 	// Calculate scaling from resolution to displayed size
	// 	const scaleX = canvasRect.width / renderer.width;
	// 	const scaleY = canvasRect.height / renderer.height;

	// 	// Convert to screen coordinates
	// 	return new PIXI.Point(
	// 		canvasRect.left + globalPos.x * scaleX,
	// 		canvasRect.top + globalPos.y * scaleY
	// 	);
	// }

	protected CreatePlusOneTargetResponsive() {

		// // const position = this.spineFrame.getGlobalPosition(new PIXI.Point());
		// let centerStarts: PIXI.IPointData = null;

		// if (GetOrientation() == Orientation.Landscape) {

		// 	centerStarts = {
		// 		x: Scale.W(1920),//position.x, //* this.scale,
		// 		y: - Scale.H(1080) //* this.scale
		// 	}
		// }
		// else {
		// 	centerStarts = {
		// 		x: this.responsiveView.availableWidth / 2 * (this.responsiveStatsContainer.percentWidth),//position.x, //* this.scale,
		// 		y: - this.responsiveView.availableHeight * (this.responsiveStatsContainer.percentHeight + this.baseGameContainer.percentHeight) //* this.scale
		// 	}
		// }

		NextTask(() => {

			const globalTarget = this.spineFrame.parent.toGlobal(this.spineFrame.position);
			console.log("CreatePlusOneTargetResponsive:", globalTarget);
			this.plusOneTarget = globalTarget;

			this.plusOneAnim.SetGlobalTarget(globalTarget as any as Point);
		});
	}

	private SetToDefault(): void {

		this.bonusGameAwardViewPIXIAPP.position.x = 0;
		this.bonusGameAwardViewPIXIAPP.position.y = 0;

		this.bonusGameInfoStatsPIXIAPP.scale.set(1);
		this.bonusGameInfoStatsPIXIAPP.position.x = 0;
		this.bonusGameInfoStatsPIXIAPP.position.y = 0;

	}
}